import { BrowserRouter, Routes, Route, HashRouter, Navigate } from 'react-router-dom'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Service'
import Contact from './pages/Contact'
import Project from './pages/Project'
import TestimonialsPage from './pages/Testimonals'
import { SERVICES_LIST } from './components/servicedata';
import TeamPage from './pages/Team';
import ProjectDetailPage from './components/Projects/projectdetailpage'

// --- ADMIN IMPORTS ---
import AdminAddProject from './admin/adminaddproject'
import AdminAddClient from './admin/adminaddclient'
import AdminAddState from './admin/adminaddstate'
import AdminEditProject from './admin/admineditproject'
import AdminDashboard from './admin/admindashboard'
import AdminLogin from './admin/adminlogin' // You need to create this
import ProtectedRoute from './admin/protectedroute' // You need to create this
import AdminLayout from './admin/adminlayout' // You need to create this

export default function App() {
    return (
        <HashRouter>
            <Routes>
                {/* --- PUBLIC ROUTES --- */}
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/project" element={<Project />} />
                <Route path="/projects" element={<Project />} />
                <Route path="/project/:projectId" element={<ProjectDetailPage />} />
                <Route path="/contact" element={<Contact />} />
                <Route path='/testimonals' element={<TestimonialsPage />} />
                <Route path='/team' element={<TeamPage/>}/>

                {/* --- LOGIN ROUTE --- */}
                <Route path="/admin-login" element={<AdminLogin />} />

                {/* --- PROTECTED ADMIN ROUTES --- */}
                {/* We wrap these in ProtectedRoute and AdminLayout */}
                
                <Route path="/admin-panel" element={
                    <ProtectedRoute>
                        <AdminLayout><AdminDashboard /></AdminLayout>
                    </ProtectedRoute>
                } />

                <Route path="/admin-panel-addproject" element={
                    <ProtectedRoute>
                        <AdminLayout><AdminAddProject /></AdminLayout>
                    </ProtectedRoute>
                } />

                <Route path="/admin-panel-client" element={
                    <ProtectedRoute>
                        <AdminLayout><AdminAddClient /></AdminLayout>
                    </ProtectedRoute>
                } />

                <Route path="/admin-panel-state" element={
                    <ProtectedRoute>
                        <AdminLayout><AdminAddState /></AdminLayout>
                    </ProtectedRoute>
                } />

                <Route path="/admin-panel-edit-project/:id" element={
                    <ProtectedRoute>
                        <AdminLayout><AdminEditProject /></AdminLayout>
                    </ProtectedRoute>
                } />

                {/* Dynamic Service Routes */}
                {SERVICES_LIST.map((i, index) => {
                    const ServiceComponent = i.component;
                    return (
                        <Route key={index} path={i.path} element={ServiceComponent ? <ServiceComponent /> : <Services />} />
                    )
                })}

                {/* Redirect /admin to Dashboard */}
                <Route path="/admin" element={<Navigate to="/admin-panel" />} />
            </Routes>
        </HashRouter>
    )
}